import { SCBOneDevicesTable } from "./SCBOneDevicesTable";
import { useActiveUserRoles } from "../../util/useActiveUserRoles";

export function SCBOneDevices() {
  const { isSolutionOperator } = useActiveUserRoles();

  return (
    <SCBOneDevicesTable currentUserIsSolutionOperator={isSolutionOperator} />
  );
}
